var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommandReactionItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54417 30.9057L18.2608 35.9507C18.3373 35.9834 18.4186 36 18.4999 36C18.5815 36 18.6627 35.9834 18.7392 35.9507L30.4558 30.9057C30.6847 30.8072 30.8331 30.5778 30.8331 30.3244V25.5124L36.6472 22.6962C36.8341 22.6053 36.9642 22.4249 36.9937 22.2158C37.0232 22.0064 36.9474 21.7958 36.7932 21.6551L31.2432 16.6101L31.2396 16.6144C31.1803 16.5608 31.115 16.5143 31.0373 16.4863L27.2572 15.1336C29.0954 13.7772 31.2056 12.6788 33.3585 12.0097L33.0002 10.8026C30.454 11.594 27.9621 12.955 25.8625 14.6341L21.6518 13.1272C21.8831 12.7687 22.1179 12.4125 22.3691 12.0676C23.0911 11.077 23.7936 10.3127 24.5057 9.74954C24.6568 10.7444 25.35 11.6457 26.3063 11.9623C27.5526 12.3761 29.0042 11.7169 29.542 10.4953C29.7437 10.0378 29.8027 9.5614 29.7139 9.11768C29.5567 8.33186 28.9142 7.66891 28.0756 7.42749C27.7579 7.33604 27.4156 7.30063 27.0524 7.32465C28.3782 6.1958 30.0216 5.46571 31.7361 5.25171L31.5868 4C29.4402 4.26728 27.3897 5.24863 25.8137 6.76269C25.4924 7.07123 25.0883 7.50078 24.8077 8.04365C23.6219 8.69829 22.5103 9.76278 21.3799 11.3141C21.0523 11.7637 20.741 12.2246 20.4456 12.6958L18.704 12.0719C18.5721 12.0248 18.4285 12.0248 18.2966 12.0719L13.5674 13.7646C12.9845 12.9775 12.3489 12.2865 11.6611 11.7005C9.9846 10.2715 7.98405 9.46502 6.02868 9.42776C4.11064 9.39697 2.40458 10.1563 1.46964 11.4742C0.887608 12.2945 0.648229 13.3994 0.830097 14.4294C0.988478 15.3266 1.44857 16.0746 2.12635 16.5343L2.80836 15.4837C2.41301 15.2158 2.14171 14.761 2.04385 14.2055C1.92221 13.5173 2.0845 12.7543 2.46811 12.2151C3.16607 11.2307 4.49304 10.657 6.00519 10.6896C7.68114 10.7213 9.40979 11.425 10.8714 12.6705C11.3917 13.1145 11.8795 13.6297 12.3365 14.2067L5.96274 16.4884C5.88505 16.5162 5.81941 16.5627 5.76039 16.6162L5.75678 16.6119L0.206809 21.6569C0.0526434 21.7977 -0.0232351 22.0083 0.00627318 22.2177C0.0351793 22.4271 0.165257 22.6078 0.352845 22.698L6.16658 25.5124V30.3244C6.16658 30.5778 6.31533 30.8072 6.54417 30.9057ZM25.7327 9.08905C25.7408 9.04871 25.7508 9.00837 25.7625 8.96803C25.9555 8.87904 26.1509 8.8036 26.3488 8.74048C26.8935 8.5665 27.3626 8.53232 27.7426 8.64256C28.1286 8.75372 28.4423 9.05271 28.5059 9.37111C28.5417 9.55093 28.5104 9.76648 28.417 9.97833C28.1391 10.609 27.3301 10.9754 26.6863 10.7635C26.0425 10.5492 25.5966 9.76709 25.7327 9.08905ZM7.39991 26.1098L12.0694 28.3718C12.1532 28.4122 12.2432 28.4325 12.3332 28.4325C12.4826 28.4325 12.6301 28.3767 12.746 28.2702L17.8832 23.5417V34.4194L7.39991 29.9056V26.1098ZM29.5998 29.9056L19.1165 34.4194V23.5417L24.254 28.2702C24.3699 28.3767 24.5174 28.4325 24.6665 28.4325C24.7565 28.4325 24.8465 28.4122 24.9306 28.3718L29.5998 26.1098V29.9056ZM24.774 27.0521L19.6495 22.3356L30.7088 17.8113L35.2768 21.9639L24.774 27.0521ZM13.0962 15.2694C13.4651 15.8446 13.8083 16.4669 14.1224 17.1397L15.2353 16.5962C14.9444 15.973 14.6267 15.391 14.2901 14.8423L18.4999 13.3353L19.803 13.8012C19.2093 14.8706 18.6874 15.9819 18.2602 17.1354L19.4134 17.5825C19.8449 16.4176 20.379 15.2996 20.9894 14.2255L24.7628 15.5758C24.1368 16.1528 23.55 16.7526 23.0324 17.3808L23.976 18.1928C24.5957 17.4399 25.3148 16.7249 26.0973 16.054L29.0765 17.1203L18.4999 21.4469L7.92353 17.1209L13.0962 15.2694ZM6.29124 17.8113L17.3505 22.3356L12.226 27.0521L1.72317 21.9639L6.29124 17.8113Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5688 0.948684C11.4939 0.634978 11.3363 0.392422 11.1012 0.22866C10.7798 0.00462598 10.4065 -0.00742833 10.1581 0.0022739C8.81774 0.0557832 7.57856 0.799328 7 1.89656L8.19896 2.41549C8.56283 1.72545 9.3736 1.23828 10.2171 1.20447C10.2372 1.20388 10.2544 1.20329 10.269 1.20329L10.2723 1.20447C10.3546 1.5467 10.2006 1.93508 10.0219 2.3855C9.89703 2.69862 9.76893 3.02232 9.7031 3.3766C9.68137 3.49744 9.61359 3.86671 9.87725 4.18571C10.0877 4.43973 10.4205 4.5735 10.8596 4.55439C11.3528 4.54293 11.8121 4.44943 12.2564 4.35917C12.6024 4.28861 12.9345 4.22128 13.2812 4.20247L12.7697 6.21554C12.726 6.38782 12.6527 6.67625 12.7863 6.98495C13.0334 7.55415 13.7534 7.71791 14.3378 7.58708C14.4535 7.56121 14.5683 7.52563 14.6819 7.48976C14.8074 7.44978 14.9316 7.39745 15.0081 7.41185C15.1495 7.41803 15.3528 7.71909 15.4025 8.09777C15.4164 8.2042 15.4265 8.31269 15.4359 8.42236C15.4809 8.93363 15.5328 9.51283 15.9684 10L17 9.24058C16.8239 9.04359 16.7928 8.6952 16.76 8.32533C16.7487 8.20067 16.7376 8.07601 16.7214 7.95459C16.6105 7.11755 16.0582 6.25287 15.0743 6.20877C14.7477 6.19495 14.4681 6.28169 14.244 6.35284C14.1918 6.3696 14.1393 6.38665 14.0861 6.40164L14.6387 4.22922C14.6737 4.09133 14.7477 3.80585 14.5894 3.51243C14.4892 3.32456 14.2204 3.00674 13.5555 2.98998C12.9854 2.97557 12.4694 3.08141 11.9661 3.18432C11.6665 3.24577 11.3788 3.30427 11.0746 3.33191C11.1271 3.15903 11.1982 2.98028 11.2721 2.79358C11.4871 2.24761 11.7329 1.62843 11.5688 0.948684Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.50165L17.8635 3L19 6.49835L18.1365 7L17 3.50165Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.26478L21.4621 8C22.1202 6.59048 22.9742 5.29376 24 4.14647L22.8092 3C21.6727 4.26873 20.7279 5.70459 20 7.26478Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.01 3L20.2336 2.93889C20.1755 2.10732 20.4476 1.26894 21 0.578535L19.9842 2.03727e-10C19.2816 0.877525 18.9352 1.94293 19.01 3Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10.3304L35.2237 12C35.8261 11.8475 36.4238 11.7447 37 11.6945L36.9229 10C36.2979 10.0543 35.6509 10.1658 35 10.3304Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 2.03727e-10H28V1H27V2.03727e-10Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35 7H36V8H35V7Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H14V11H12V10Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H7V15H6V13Z",
    fill: "url(#paint9_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 2.8469e-8,
    y1: 18.2068,
    x2: 37,
    y2: 18.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandReactionItem);
export default __webpack_public_path__ + "static/media/command-reaction-item.d4833d4b162106db13f6bb8b7690f7cd.svg";
export { ForwardRef as ReactComponent };